<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.chosen_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <a
            v-if="isPdf(data.commercial_register_image)"
            :href="data.commercial_register_image"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("PLACEHOLDERS.pdf_title") }}
          </a>
          <!-- Render image upload component for non-PDF files -->
          <base-image-upload-input
            v-else
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.commercial_register_image')"
            :preSelectedImage="data.commercial_register_image"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.selection_priority')"
            v-model="data.selection_priority"
            disabled
          />
          <!-- End:: count_stores Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "CreateArea",
  components: {
    UploadsPhotos,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        commercial_register_image: null,
        name: null,
        phone: null,
        email: null,
        commercial_register: null,
        desc_en: null,
        selection_priority: null,
        email: null,
        commercial_register: null,
        commercial_register_image: null,
        tax_file: null,
        license: null,
        commercial_register_image: null,
        commission_type: null,
        presintage: null,
      },
      additionalImages: [],
      imgUrls: [],
      markers: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    isPdf(fileUrl) {
      return (
        fileUrl &&
        typeof fileUrl === "string" &&
        fileUrl.toLowerCase().endsWith(".pdf")
      );
    },
    getDay(id) {
      if (id == 1) {
        return this.$t("PLACEHOLDERS.1");
      }
      if (id == 2) {
        return this.$t("PLACEHOLDERS.2");
      }
      if (id == 3) {
        return this.$t("PLACEHOLDERS.3");
      }
      if (id == 4) {
        return this.$t("PLACEHOLDERS.4");
      }
      if (id == 5) {
        return this.$t("PLACEHOLDERS.5");
      }
      if (id == 6) {
        return this.$t("PLACEHOLDERS.6");
      }
      if (id == 7) {
        return this.$t("PLACEHOLDERS.7");
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `selected-providers/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.commercial_register_image =
          res.data.data.commercial_registration_file;
        this.data.name = res.data.data.name;
        this.data.phone = res.data.data.mobile;
        this.data.email = res.data.data.email;
        this.data.commercial_register =
          res.data.data.commercial_registration_number;
        this.data.selection_priority = res.data.data.selection_priority;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
a {
  display: inline-block;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
}
a:hover {
  background-color: #0056b3;
  color: white !important;
}
</style>
